import React from 'react';

const Policies = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="policies-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1
          className="text-4xl sm:text-5xl font-bold mb-12 text-center"
          style={{ fontFamily: 'Playfair Display, serif' }}
          data-testid="policies-title"
        >
          Store Policies
        </h1>

        <div className="space-y-10">
          {/* Shipping Fees Section */}
          <section className="bg-gradient-to-r from-[#D4AF37] to-[#B5952F] p-6 rounded-lg text-white">
            <h2 className="text-2xl font-bold mb-4 flex items-center gap-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-2xl">📦</span> Shipping Fees (United States)
            </h2>
            <p className="mb-4 text-white/90">We offer simple, transparent shipping based on your order total:</p>
            <div className="bg-white/10 rounded-lg p-4 space-y-3">
              <div className="flex justify-between items-center border-b border-white/20 pb-2">
                <span>Orders below $10</span>
                <span className="font-bold">$2.99 shipping</span>
              </div>
              <div className="flex justify-between items-center border-b border-white/20 pb-2">
                <span>Orders $10 – $29.99</span>
                <span className="font-bold">$4.99 shipping</span>
              </div>
              <div className="flex justify-between items-center border-b border-white/20 pb-2">
                <span>Orders $30 – $74.99</span>
                <span className="font-bold">$7.99 shipping</span>
              </div>
              <div className="flex justify-between items-center">
                <span>Orders $75 and above</span>
                <span className="font-bold text-lg">FREE SHIPPING</span>
              </div>
            </div>
            <p className="mt-4 flex items-center gap-2 text-white font-medium">
              <span>🚗</span> Local Pickup is always FREE at our store in Reynoldsburg, Ohio.
            </p>
          </section>

          {/* International Shipping */}
          <section className="bg-[#FAFAFA] p-6 rounded-lg border-l-4 border-[#D4AF37]">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-2xl">🌍</span> International Shipping
            </h2>
            <p className="text-gray-700 mb-4">
              At this time, <strong>Nepora ships within the United States only.</strong>
            </p>
            <p className="text-gray-700 mb-4">
              Customers outside the USA (including Canada) are welcome to contact us for special international orders. 
              International shipping rates vary by destination, size, and weight and will be quoted manually before payment.
            </p>
            <div className="bg-white p-4 rounded-lg border border-gray-200">
              <p className="text-sm font-medium text-gray-800 mb-2">Please note:</p>
              <ul className="list-disc pl-6 text-gray-600 text-sm space-y-1">
                <li>International shipping fees are non-refundable</li>
                <li>Customs duties, taxes, and import fees (if any) are the responsibility of the customer</li>
                <li>Delivery times may vary due to customs processing</li>
              </ul>
            </div>
            <p className="mt-4 text-[#8B1F1F] font-medium">
              For international orders, please <a href="/contact" className="underline hover:text-[#D4AF37]">contact us</a> before placing an order.
            </p>
          </section>

          {/* Return & Exchange Policy Header */}
          <div className="text-center pt-6">
            <h2 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              Return & Exchange Policy
            </h2>
            <p className="text-gray-600">
              At Nepora, we want you to love what you buy. Please read our return policy carefully before placing an order.
            </p>
          </div>

          {/* Return Window */}
          <section className="bg-[#FAFAFA] p-6 rounded-lg border-l-4 border-[#D4AF37]">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-2xl">🕒</span> Return Window
            </h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Returns or exchanges are accepted within <strong>7 days</strong> of purchase.</li>
              <li>Item must be unused, unworn, and in original condition with tags and packaging.</li>
            </ul>
          </section>

          {/* Final Sale Items */}
          <section className="bg-[#FFF5F5] p-6 rounded-lg border-l-4 border-[#8B1F1F]">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2 text-[#8B1F1F]" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-2xl">🚫</span> Final Sale Items (Not Returnable)
            </h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>All Nepali Jewelry (including artificial/fashion jewelry)</li>
              <li>Sarees</li>
              <li>Undergarments</li>
              <li>Cosmetics, face products, beauty items</li>
              <li>Clearance or sale items</li>
              <li>Below $10 items</li>
            </ul>
            <p className="mt-4 text-sm text-[#8B1F1F] font-medium">
              These items are FINAL SALE due to hygiene and pricing reasons.
            </p>
          </section>

          {/* Exchanges */}
          <section className="bg-[#FAFAFA] p-6 rounded-lg border-l-4 border-[#D4AF37]">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-2xl">🔁</span> Exchanges
            </h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Clothing items (non-sale) may be exchanged for a different size or item of equal value.</li>
              <li>Exchanges are subject to availability.</li>
              <li>Customer is responsible for return shipping costs (if applicable).</li>
            </ul>
          </section>

          {/* In-Store Purchases */}
          <section className="bg-[#FAFAFA] p-6 rounded-lg border-l-4 border-[#D4AF37]">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-2xl">📍</span> In-Store Purchases
            </h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>In-store purchases are eligible for <strong>exchange only</strong>.</li>
              <li>No cash refunds for in-store purchases.</li>
            </ul>
          </section>

          {/* Online Orders */}
          <section className="bg-[#FAFAFA] p-6 rounded-lg border-l-4 border-[#D4AF37]">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-2xl">📦</span> Online Orders
            </h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Shipping fees are non-refundable.</li>
              <li>Customer is responsible for return shipping unless the item arrived damaged or incorrect.</li>
            </ul>
          </section>

          {/* Damaged or Wrong Item */}
          <section className="bg-[#F5F9FF] p-6 rounded-lg border-l-4 border-blue-500">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-2xl">❗</span> Damaged or Wrong Item
            </h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Please contact us within <strong>48 hours</strong> of delivery with photos.</li>
              <li>We will replace or resolve the issue promptly.</li>
            </ul>
          </section>

          {/* Store Location */}
          <section className="bg-black text-white p-6 rounded-lg">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2 text-[#D4AF37]" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-2xl">📍</span> Store Location
            </h2>
            <div className="space-y-2">
              <p className="font-semibold text-lg">Nepora Clothing & Accessories</p>
              <p className="text-gray-300">6575 E Livingston Ave</p>
              <p className="text-gray-300">Reynoldsburg, OH 43068</p>
              <p className="text-[#D4AF37] mt-3 font-medium">🕘 Open Daily: 9AM – 9PM</p>
            </div>
          </section>
        </div>

        <div className="mt-12 p-6 bg-gradient-to-r from-[#D4AF37] to-[#8B1F1F] rounded-lg text-center text-white">
          <p className="text-lg mb-4 font-medium">
            Questions about our policies? We're here to help!
          </p>
          <a
            href="/contact"
            className="inline-block bg-white text-[#8B1F1F] py-3 px-8 rounded-full hover:bg-gray-100 transition-colors font-semibold"
            data-testid="contact-button"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default Policies;
